export default "__VITE_ASSET__x2VG6c9j__"